'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _uniqBy2 = require('lodash/uniqBy');

var _uniqBy3 = _interopRequireDefault(_uniqBy2);

var _isEqual2 = require('lodash/isEqual');

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2, _class3, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _Dropdown = require('react-bootstrap/lib/Dropdown');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _MenuItem = require('react-bootstrap/lib/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _Well = require('react-bootstrap/lib/Well');

var _Well2 = _interopRequireDefault(_Well);

var _common = require('../../common');

var _utils = require('../../../utils');

var _constants = require('../../../constants');

var _LawFirmModal = require('../../common-modal-lawfirm/LawFirmModal');

var _LawFirmModal2 = _interopRequireDefault(_LawFirmModal);

var _mightyFields = require('../../../lib/mighty-fields');

var _renderUtils = require('../../../lib/mighty-fields/renderUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var ROUTING = _constants.AppConstants.ROUTING,
    USER_FLOW = _constants.AppConstants.USER_FLOW;
var getOrDefault = _utils.FormattingUtils.getOrDefault;


var LAW_FIRM_FIELD_SETS = [{ field: 'phone_number', label: 'Phone #', type: 'phone' }, { field: 'fax_number', label: 'Fax #', type: 'phone' }, { field: 'website', type: 'url' }, { field: 'address', type: 'address' }];

var LawFirmOfficeInfo = (_dec = (0, _mobxReact.inject)('Clients', 'OptionsStore', 'SessionStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp2 = _class3 = function (_Component) {
  _inherits(LawFirmOfficeInfo, _Component);

  function LawFirmOfficeInfo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LawFirmOfficeInfo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LawFirmOfficeInfo.__proto__ || Object.getPrototypeOf(LawFirmOfficeInfo)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'lawfirms', _descriptor, _this), _initDefineProp(_this, 'editing', _descriptor2, _this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LawFirmOfficeInfo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          attorney = _props._case.attorney,
          lawFirmContacts = _props.lawFirmContacts;

      this.fetchRelationships(attorney, lawFirmContacts);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var attorney = nextProps._case.attorney,
          lawFirmContacts = nextProps.lawFirmContacts,
          lastContactInfo = { attorney: this.props._case.attorney, lawFirmContacts: this.props.lawFirmContacts },
          newContactInfo = { attorney: attorney, lawFirmContacts: lawFirmContacts };

      if (!(0, _isEqual3.default)(lastContactInfo, newContactInfo)) {
        this.fetchRelationships(attorney, lawFirmContacts);
      }
    }
  }, {
    key: 'fetchRelationships',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(attorney, lawFirmContacts) {
        var Clients, attorneyRelationships, contactRelationships, relationships, lawfirms, uniqLawfirms;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Clients = this.props.Clients;

                if (!attorney) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return Clients.relationships.list({ params: { page_size: 'off', second_party: attorney.id } });

              case 4:
                _context.t0 = _context.sent;
                _context.next = 8;
                break;

              case 7:
                _context.t0 = [];

              case 8:
                attorneyRelationships = _context.t0;

                if ((0, _isEmpty3.default)(lawFirmContacts)) {
                  _context.next = 15;
                  break;
                }

                _context.next = 12;
                return Clients.relationships.list({ params: { page_size: 'off', second_party: lawFirmContacts.map(function (contact) {
                      return contact.id;
                    }) } });

              case 12:
                _context.t1 = _context.sent;
                _context.next = 16;
                break;

              case 15:
                _context.t1 = [];

              case 16:
                contactRelationships = _context.t1;
                relationships = [].concat(_toConsumableArray(attorneyRelationships), _toConsumableArray(contactRelationships));
                lawfirms = relationships.map(function (relationship) {
                  return relationship.first_party;
                });
                uniqLawfirms = (0, _uniqBy3.default)(lawfirms, 'id');

                this.lawfirms = uniqLawfirms.sort(function (lawfirm) {
                  return lawfirm.name;
                });

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchRelationships(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return fetchRelationships;
    }()
  }, {
    key: 'openEditLawFirmModal',
    value: function openEditLawFirmModal() {
      var _props2 = this.props,
          SessionStore = _props2.SessionStore,
          UiStore = _props2.UiStore,
          _case = _props2._case;

      SessionStore.trackEvent('EDIT_LAWFIRM_MODAL', { caseId: _case.id });
      this.editing = true;
      UiStore.modals.LawFirm.open();
    }
  }, {
    key: 'openLawFirmModal',
    value: function openLawFirmModal() {
      var _props3 = this.props,
          SessionStore = _props3.SessionStore,
          UiStore = _props3.UiStore,
          _case = _props3._case;

      SessionStore.trackEvent('OPEN_LAWFIRM_MODAL', { caseId: _case.id });
      this.editing = false;
      UiStore.modals.LawFirm.open();
    }
  }, {
    key: 'renderEdit',
    value: function renderEdit() {
      var onRemoveLawFirmFromCase = this.props.onRemoveLawFirmFromCase;


      return _react2.default.createElement(
        _Dropdown2.default,
        { id: 'dropdown-lawfirm-office-info', bsStyle: 'link', className: 'btn-edit pull-right', pullRight: true },
        _react2.default.createElement(
          _Dropdown2.default.Toggle,
          { noCaret: true, className: 'btn-link btn-edit pull-right' },
          _react2.default.createElement(_common.Icon, { type: 'pencil' })
        ),
        _react2.default.createElement(
          _Dropdown2.default.Menu,
          null,
          _react2.default.createElement(
            _MenuItem2.default,
            { onSelect: this.openLawFirmModal },
            'Change Law Firm'
          ),
          _react2.default.createElement(
            _MenuItem2.default,
            { onSelect: onRemoveLawFirmFromCase },
            'Remove Law Firm'
          )
        )
      );
    }
  }, {
    key: 'renderLawfirmName',
    value: function renderLawfirmName() {
      var _props4 = this.props,
          lawfirm = _props4._case.lawfirm,
          SessionStore = _props4.SessionStore;


      if (SessionStore.isMightyFreeUser) {
        return _react2.default.createElement(
          'p',
          null,
          getOrDefault(lawfirm.name)
        );
      }

      return _react2.default.createElement(
        _common.Link,
        { to: { pathname: ROUTING.lawfirmList + '/' + lawfirm.id, state: USER_FLOW.FROM_CASE_DETAIL_PAGE } },
        _react2.default.createElement(
          'b',
          null,
          getOrDefault(lawfirm.name)
        )
      );
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _props5 = this.props,
          _case = _props5._case,
          lawfirm = _props5._case.lawfirm,
          OptionsStore = _props5.OptionsStore,
          warningReasons = OptionsStore.warningReasons,
          warningReason = (0, _get3.default)(lawfirm, 'warning.reason'),
          formattedWarning = warningReasons[warningReason],
          warningTooltipMessage = 'Changes will not be reflected in the Law Firm Portal as the case info has been locked by the law firm',
          warningTooltipId = 'registry-migration-error';


      return _react2.default.createElement(
        'div',
        { className: 'contact-details info-well' },
        _react2.default.createElement(
          'h3',
          { className: 'dropdown-arrow' },
          'Law Firm Office Info',
          this.renderEdit()
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'info name' },
            this.renderLawfirmName(),
            ' ',
            (0, _renderUtils.renderWarningTooltip)(warningTooltipMessage, warningTooltipId),
            _case.migrate_to_registry && !_case.is_editable_on_registry && _react2.default.createElement(
              'span',
              { 'data-tip': true, 'data-for': 'registry-migration-error', id: 'icon-registry-migration-warning' },
              _react2.default.createElement(_common.Icon, { type: 'exclamation-triangle' }),
              ' '
            )
          ),
          LAW_FIRM_FIELD_SETS.map(function (fieldConfig) {
            return _react2.default.createElement(_mightyFields.CardRow, { key: fieldConfig.field, fieldConfig: fieldConfig, model: lawfirm });
          }),
          formattedWarning && _react2.default.createElement(
            'div',
            { className: 'info flag flagged ellipsis' },
            _react2.default.createElement(_common.Icon, { type: 'exclamation-triangle' }),
            ' ',
            formattedWarning
          )
        )
      );
    }
  }, {
    key: 'renderEmpty',
    value: function renderEmpty() {
      return _react2.default.createElement(
        'div',
        { className: 'core empty' },
        _react2.default.createElement(_common.EmptyStateButton, { emptyText: 'Add Law Firm', iconType: 'building-o', onClick: this.openLawFirmModal })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          _case = _props6._case,
          lawfirm = _props6._case.lawfirm,
          onLawFirmModalSave = _props6.onLawFirmModalSave,
          UiStore = _props6.UiStore,
          contactRelatedLawfirms = !this.editing && this.lawfirms || [],
          lawFirmModalProps = { contactRelatedLawfirms: contactRelatedLawfirms, editOnly: this.editing };


      return _react2.default.createElement(
        _Well2.default,
        { className: 'well-lawfirm' },
        lawfirm === null ? this.renderEmpty() : this.renderBody(),
        UiStore.modals.LawFirm.showing() && _react2.default.createElement(_LawFirmModal2.default, _extends({
          caseId: _case.id,
          lawfirm: lawfirm || undefined,
          onSave: onLawFirmModalSave
        }, lawFirmModalProps))
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return LawFirmOfficeInfo;
}(_react.Component), _class3.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  lawFirmContacts: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string
  })),
  onLawFirmModalSave: _propTypes2.default.func.isRequired,
  onRemoveLawFirmFromCase: _propTypes2.default.func.isRequired,
  OptionsStore: _propTypes2.default.object.isRequired,
  SessionStore: _propTypes2.default.object,
  UiStore: _propTypes2.default.object.isRequired
}, _temp2), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'lawfirms', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'editing', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'fetchRelationships', [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, 'fetchRelationships'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = LawFirmOfficeInfo;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ROUTING, 'ROUTING', '/app/src/components/page-case/main-contacts/LawFirmOfficeInfo.js');
  reactHotLoader.register(USER_FLOW, 'USER_FLOW', '/app/src/components/page-case/main-contacts/LawFirmOfficeInfo.js');
  reactHotLoader.register(getOrDefault, 'getOrDefault', '/app/src/components/page-case/main-contacts/LawFirmOfficeInfo.js');
  reactHotLoader.register(LAW_FIRM_FIELD_SETS, 'LAW_FIRM_FIELD_SETS', '/app/src/components/page-case/main-contacts/LawFirmOfficeInfo.js');
  reactHotLoader.register(LawFirmOfficeInfo, 'LawFirmOfficeInfo', '/app/src/components/page-case/main-contacts/LawFirmOfficeInfo.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-contacts/LawFirmOfficeInfo.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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